import { UpdatePassword } from 'pages/updatePassword'

export const UpdatePasswordManagementRoute = () => {
  return <UpdatePassword />
}